export default __webpack_public_path__ + "static/media/red car.95558963.jpg";